import { atsApiQuery } from '..';

export const atsReports = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getLastRefreshTime: builder.query({
        query: ({ scope = 'applications' }) => {
          return {
            url: `/reports/filters/list?attribute=report_timestamp&scope=${scope}`,
            method: 'get',
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGetLastRefreshTimeQuery } = atsReports;
